import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {BasketAnalysisReportModel} from "./basket-analysis-report.model";

@Component({
    selector: "wbo-basket-analysis-report",
    templateUrl: "./basket-analysis-report.component.html",
    providers: [provideReportModel(BasketAnalysisReportModel)]
})
export class BasketAnalysisReportComponent extends AbstractReportPage {
    constructor(public model: BasketAnalysisReportModel) {
        super();
    }
}
